import { Injectable, signal } from '@angular/core';

/**
 * Simple service to receive and update loading signal
 * @class LoadingService
 * @typedef {LoadingService}
 */
@Injectable( {
    providedIn: 'root'
} )
export class LoadingService {
    /** signal current state to {@link LoadingComponent} */
    loading = signal( false );

    /**
     * public interface to trigger loading
     * @param state {boolean} the state of loading, default is false
     */
    setLoading( state: boolean = false ) {
        this.loading.set( state );
    }
}
